import { useState } from "react";
import InputPropsType from "../../Types/InputPropsType";
import Icon from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";

const StyledPassword = ({
  text,
  placeholder,
  onChange,
  className = "styledInput",
}: InputPropsType) => {
  const [show, setShow] = useState(false);

  function showPassword() {
    show ? setShow(false) : setShow(true);
  }

  function onInput(e: any) {
    onChange(e);
  }

  return (
    <div className={className}>
      <div>{text}</div>
      <div
        style={{
          padding: "0 10px 0  0 ",
          display: "flex",
          justifyContent: "space-between",
          borderRadius:"10px"
        }}
      >
        <input
          type={show ? "text" : "password"}
          placeholder={placeholder}
          onChange={onInput}
        />
        <span className="eye" onClick={showPassword}>
          <Icon icon={show ? eye : eyeOff} size={30}></Icon>
        </span>
      </div>
    </div>
  );
};

export default StyledPassword;
